import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

// Blöcke, die nur mobil (unterhalb von md = 768px) zum Slider werden.
// Die Swiper-Klassen werden erst hier per JS gesetzt und beim Wechsel auf
// Desktop wieder entfernt – das Desktop-Layout bleibt dadurch unberührt.
// Breakpoint muss mit src/scss/components/_mobile-slider.scss übereinstimmen.
const MOBILE_QUERY = '(max-width: 767.98px)';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const logoOptions = {
    slidesPerView: 2.3,
    spaceBetween: 24,
    autoplay: reducedMotion ? false : {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    breakpoints: {
        480: {
            slidesPerView: 3.3
        }
    }
};

const SLIDERS = {
    '.sponsor-slider': logoOptions,
    '.partner-slider': logoOptions,
    '.news-slider': {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
            480: {
                slidesPerView: 1.8
            }
        }
    }
};

function mobileSlider(el, options, mobile){
    const wrapper = el.firstElementChild;
    if (!wrapper) return;

    let swiperInstance = null;
    let pagination = null;

    function init() {
        el.classList.add('swiper');
        wrapper.classList.add('swiper-wrapper');
        [...wrapper.children].forEach(slide => slide.classList.add('swiper-slide'));

        pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        el.appendChild(pagination);

        swiperInstance = new Swiper(el, {
            modules: [Pagination, Autoplay],
            watchOverflow: true,
            pagination: {
                el: pagination,
                clickable: true
            },
            ...options
        });
    }

    function destroy() {
        swiperInstance.destroy(true, true);
        swiperInstance = null;

        pagination.remove();
        pagination = null;

        // swiper-backface-hidden entfernt Swiper beim destroy() nicht selbst
        el.classList.remove('swiper', 'swiper-backface-hidden');
        wrapper.classList.remove('swiper-wrapper');
        [...wrapper.children].forEach(slide => slide.classList.remove('swiper-slide'));
    }

    function update() {
        if (mobile.matches && !swiperInstance) {
            init();
        } else if (!mobile.matches && swiperInstance) {
            destroy();
        }
    }

    update();
    mobile.addEventListener('change', update);
}

export default function mobileSliders(){
    const mobile = window.matchMedia(MOBILE_QUERY);

    Object.entries(SLIDERS).forEach(([selector, options]) => {
        document.querySelectorAll(selector).forEach(el => mobileSlider(el, options, mobile));
    });
}
